/*
 *
 * AdministratorFormDialog14852
 *
 */


import {ReceptionFormDialog14852} from '../ReceptionView';

export class AdministratorFormDialog14852 extends ReceptionFormDialog14852 {
}
